module.exports = __webpack_public_path__ + "static/img/11bg_8.acc1766.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/11bg_8.png
// module id = 636
// module chunks = 1